import { Illustration, Loader } from '@profgeosoft-ui/react';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { usePadPreparationStore } from 'src/pages/well-pad-preparation/use-pad-preparation-store';
import { PadPreparation } from 'src/store/well-pad-preparation/entities';

import { PadCollapse } from './pad-collapse';

import styles from './well-pad-preparation-pads-list.module.scss';

export const WellPadPreparationPadsList = observer(function WellPadPreparationPadsList() {
  const [expandedPadsMap] = useState(() => new Map<number, boolean>());
  const { isLoading, noResultReason, pads } = usePadPreparationStore();

  return (
    <div className={styles.wrapper}>
      {isLoading && <Loader />}
      {noResultReason === 'noDataByFilters' && (
        <div className={styles.stubWrapper}>
          <div className={styles.imgWrapper}>
            <Illustration.NoResult />
          </div>
          <p className={styles.stubText}>Нет данных по заданным критериям</p>
        </div>
      )}

      <Virtuoso<PadPreparation>
        style={{ height: '100%' }}
        className={styles.padsList}
        data={pads}
        itemContent={(_, pad) => {
          const isExpanded = !!expandedPadsMap.get(pad.id);

          return (
            <PadCollapse
              key={pad.id}
              pad={pad}
              isExpanded={isExpanded}
              onExpandedChange={(is) => expandedPadsMap.set(pad.id, is)}
            />
          );
        }}
      />
    </div>
  );
});
